<template>
  <el-select
    :value="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    clearable
    :placeholder="placeholder"
    @change="selected"
  >
    <el-option
      v-for="(stageConfig, stageType) in $companyConfiguration.cardStages.getTypesConfig()"
      :key="stageType"
      :label="stageConfig.showName"
      :value="stageType"
    >
    </el-option>
  </el-select>

</template>

<script>

export default {
  name: "cards-stage-select",
  components: {},
  props: {
    value: {},
    size: {type: String, default: '' },
    disabled: {type: Boolean, default: false },
    multiple: {type: Boolean, default: false },
    placeholder: {type: String, default: 'Этап' },
  },

  data() {
    return {
      localValue: this.value,
    }
  },
  beforeMount() {},
  watch: {
    value(newValue){
      this.localValue = newValue;
    }
  },
  computed: {},
  methods: {
    selected(value) {
      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },

}
</script>

<style scoped>

</style>